
 import { mapState } from 'vuex'
 import dayjs from 'dayjs' // 时间转换
export default {
  props: {
    item: {
        type: Object,
        default: () => {}
    },
    state:{
      type: [Number,String],
      default: 1
    }
  },
  data() {
      return {
        leverageFrame:true,
        serverIPObj:[],
        isIpDialog:false,
        updateDate:'',
        serverIpPop:false,
        leverageState:false,
        disleverageState:false
      };
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
     isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
   },
  created() {
    this.disleverageState = !!this.item.leverage
  },
  mounted() {

  },
  
  beforeDestroy() {
  },
  methods: {
    openleverage(){
      console.log('打开');
      this.disleverageState = !!this.item.leverage
      this.leverageState = true
    },
    closeleverage(e) {
      console.log('触发');
      this.disleverageState=false
      this.leverageState = false
    },
    pingIcon(i) {
      if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
      else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
      else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
      else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
    },
    openIpDialogh5(item) {
      console.log(item, 8886)
      this.$emit('openip')
      if (item.serverIPList.list.length) {
        this.serverIPObj = item.serverIPList
       this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        this.serverIpPop = true
      }
    },
    openIpDialog(item) {
      console.log(item, 8886)
      console.log('触发');
      
      this.$emit('opendialog',item)
    },
    handleMouseEnter() {
      console.log('鼠标移入');
      // 这里可以执行鼠标移入时的逻辑
      this.leverageFrame=true
    },
    handleMouseLeave() {
      console.log('鼠标移出');
      // 这里可以执行鼠标移出时的逻辑
      this.leverageFrame=false
    }
  }
};
